<template>
  <div :class="{content: true, empty: list.length === 0}">
    <div class="wrapper">
      <div class="filters">
        <evaluationFilter ref="evaluationFilter" :filters="filters" :type="'unique'" :date="dateConfig" @getFilters="getFilters" />
      </div>
      <div class="list">
        <div class="handles">
          <div class="btn" @click="getList">
            <img src="@assets/img/resources/fresh.svg" alt="fresh">
            刷新
          </div>
        </div>
        <div class="titleLine">
          <span class="title">Xnews标题</span>
          <span class="score">图片/视频</span>
          <span class="name">视频时长</span>
          <span class="score">发布平台</span>
          <span class="name">记者</span>
          <span class="score">考评</span>
          <span class="name">摄像</span>
          <span class="score">考评</span>
        </div>
        <empty :mTop="50" v-if="list.length === 0" :msg="'暂无考评数据'" />
        <div v-for="(l, i) in list" :key="i">
          <div class="item">
            <span class="grayBg"></span>
            <div class="inner">
              <div :class="{title: true, ft16: true, sec: true}">
                <span class="title" @click="goReport(l.report_id)">{{l.title}}</span>
                <img class="toggler" v-if="l.use_log.length > 0" :src="l.showRelated?icons.up:icons.down" alt="icon" @click="toggleRelated(l)">
              </div>
              <div class="score sec">
                {{`${l.img_num}/${l.video_num}`}}
              </div>
              <div class="name sec timeFont">{{l.report_durantion}}</div>
              <div class="score sec pd6">
                <div class="plat">
                  <span>电视</span>
                  <img :src="l.push_avid?icons.done:icons.undone" alt="icon" :title="`发送到电视平台${l.push_avid?'成功':'失败'}`">
                </div>
                <div class="plat">
                  <span>Knews</span>
                  <img :src="l.push_knews?icons.done:icons.undone" alt="icon" :title="`送看看${l.push_knews?'成功':'失败'}`">
                </div>
              </div>
              <div class="name sec">{{l.reporters}}</div>
              <div class="score sec">
                <div v-if="l.reporter_res.score_type == 1 && l.reporter_res.rate.filter(g => g.selected).length === 0" class="grade none" @click="showGrades(l, 'reporter_res')">
                  <img src="@assets/img/common/grade.svg" alt="grade">
                  打分
                </div>
                <div class="grade" v-if="l.reporter_res.score_type == 1 && l.reporter_res.rate.filter(g => g.selected).length === 1" @click="showGrades(l, 'reporter_res')">
                  {{l.reporter_res.rate.filter(g => g.selected)[0].title}}
                </div>
                <input placeholder="请打分" class="scorer" v-if="l.reporter_res.score_type == 0" v-model="l.reporter_res.value" @blur="postScore(l.report_id, 0, l.reporter_res.value)">
                <div class="gradeList" v-show="l.reporter_res.showGrades">
                  <div :class="{g: true, selected: g.selected}" v-for="(g, gi) in l.reporter_res.rate" :key="gi" @click="selectGrade(l, 0, g.key)">{{g.title}}</div>
                </div>
              </div>
              <div class="name sec">{{l.cameras}}</div>
              <div class="score sec">
                <div v-if="l.cameras_res.score_type == 1 && l.cameras_res.rate.filter(g => g.selected).length === 0" class="grade none" @click="showGrades(l, 'cameras_res')">
                  <img src="@assets/img/common/grade.svg" alt="grade">
                  打分
                </div>
                <div class="grade" v-if="l.cameras_res.score_type == 1 && l.cameras_res.rate.filter(g => g.selected).length === 1" @click="showGrades(l, 'cameras_res')">
                  {{l.cameras_res.rate.filter(g => g.selected)[0].title}}
                </div>
                <input placeholder="请打分" class="scorer" v-if="l.cameras_res.score_type==0" v-model="l.cameras_res.value" @blur="postScore(l.report_id, 1, l.cameras_res.value)">
                <div class="gradeList" v-show="l.cameras_res.showGrades">
                  <div :class="{g: true, selected: g.selected}" v-for="(g, gi) in l.cameras_res.rate" :key="gi" @click="selectGrade(l, 1, g.key)">{{g.title}}</div>
                </div>
              </div>
            </div>
          </div>
          <div v-show="l.showRelated" class="related" v-for="(r, ri) in l.use_log" :key="ri">
            <div class="inner">
              <div class="title" @click="goTandem(r)">
                <span class="typeIcon" :title="`${r.platform}平台`">{{r.platform}}</span>
                <span :title="`${r.is_knews?'':'串联单中的标题'}`">{{r.title}}</span>
              </div>
              <div class="section mr20">
                <img title="浏览数量" src="@assets/img/common/eye.svg" alt="image" v-if="r.is_knews">
                <img title="播出栏目" src="@assets/img/common/label.svg" alt="image" v-else>
                <span>{{r.type}}</span>
              </div>
              <div class="section mr20">
                <img :title="`${r.is_knews?'上架时间':'播出时间'}`" src="@assets/img/common/time.svg" alt="video">
                <span class="timeFont">{{r.release_time}}</span>
              </div>
              <div class="section flex1">
                <img title="knews浏览地址" src="@assets/img/common/link.svg" alt="video" v-if="r.is_knews">
                <img title="播出时长" src="@assets/img/common/video.svg" alt="video" v-else>
                <span class="link" v-if="r.is_knews" @click="goLink(r.duration)">{{r.duration}}</span>
                <span v-else>{{r.duration}}</span>
              </div>
            </div>
          </div>
        </div>
        <pages :page_count="page.page_count" :index="page.pageIndex" :total="page.total"></pages>
      </div>
    </div>
  </div>
</template>

<script>
import evaluationFilter from '@components/evaluationFilter';
import common from '@common/common';
import pages from '@components/pages';
import { apis } from '@common/config';
import empty from '@components/empty';

export default {
  name: 'departEvaluation',
  components: {
    evaluationFilter, pages, empty
  },
  data() {
    return {
      isXnew: this.$store.state.isXnew,
      icons: {
        up: require('@assets/img/common/upward.svg'),
        down: require('@assets/img/common/xiala.svg'),
        done: require('@assets/img/common/done.svg'),
        undone: require('@assets/img/common/undone.svg')
      },
      filters: [],
      dateConfig: {
        title: '发布日期',
        type: 'date',
        range: true,
        placer: ' 开始时间 ～ 结束时间'
      },
      page: {
        pageSize: 20,
        pageIndex: 1,
        page_count: 0,
        total: 0
      },
      filterOptions: {},
      searchOptions: {},
      list: []
    }
  },
  mounted() {
    const yesterday = this.getYesterday()

    this.$refs.evaluationFilter.datePicker = yesterday
  },
  methods: {
    getList() {
      const id = this.$route.params.id
      const info = {
        idstring: id,
        depart_id: '',
        start: '',
        end: '',
        status: '',
        search_option: '',
        key_words: '',
        page: this.page.pageIndex,
        pagesize: this.page.pageSize
      }

      this.searchOptions.key_words = this.$store.state.keyWord

      Object.assign(info, this.filterOptions, this.searchOptions)

      common.myFetch(apis.departEvaluation, info)
        .then((data) => {
          if (data) {
            this.list = data.list
            this.generateFilters(data.params.list_search)
            this.generateSearchs(data.params.top_search.option.list)
            this.$set(this.page, 'page_count', common.calculatePage(data.page.row_count - 0, this.page.pageSize))
            this.$set(this.page, 'total', data.page.row_count - 0)
          }
        })
    },
    generateFilters(data) {
      // 整理过滤条件数据
      this.filters.forEach((i) => {
        data.forEach((j) => {
          if (i.key === j.key) {
            j.expand = !!i.expand
          }

          if (i.list) {
            i.list.forEach((c) => {
              j.list && j.list.forEach((d) => {
                if (c.key === d.key) {
                  d.expand = !!c.expand
                }
              })
            })
          }
        })
      })

      const filters = data.filter((i) => {
        return i.key !== 'start' && i.key !== 'end'
      })

      this.filters = filters
    },
    generateSearchs(data) {
      // 整理搜索栏数据
      const types = data.map((i) => {
        return {
          name: i.title,
          code: i.key,
          selected: i.selected
        }
      })

      const filterData = {
        types: types,
        callback: (o) => {
          this.getSearch(o)
        }
      }
      this.postSearch(filterData)
    },
    postSearch(data) {
      // 发送搜索框数据
      this.$emit('filterData', data)
    },
    getSearch(d) {
      // 接收搜索框数据
      this.searchOptions = d
      this.getList()
    },
    showGrades(i, s) {
      // 显示等级列表
      this.$set(i[s], 'showGrades', !i[s].showGrades)
    },
    toggleRelated(l) {
      // 切换显示隐藏关联报道
      this.$set(l, 'showRelated', !l.showRelated)
    },
    getFilters(f) {
      // 接收过滤组件数据
      this.page.pageIndex = 1
      this.filterOptions = f

      this.getList()
    },
    getYesterday() {
      const today = +new Date()
      const yesterday = today - 24 * 60 * 60 * 1000

      return [new Date(yesterday), new Date(yesterday)]
    },
    async selectGrade(l, type, score) {
      // 选择等级
      this.$set(l.reporter_res, 'showGrades', false)

      if (!score) {
        let c = await this.$confirm('确定清空打分吗？')

        if (!c) return
      }

      this.postScore(l.report_id, type, score)
    },
    postScore(id, type, score) {
      // 考评打分
      // if (!score) return

      const info = {
        report_id: id,
        appraisal_type: type,
        appraisal_res: score
      }

      common.myFetch(apis.sectionEvaluationScore, info)
        .then((r) => {
          if (r) {
            this.$toast(r)
          }

          this.getList()
        })
    },
    goReport(id) {
      // 跳转报道详情
      common.jump(`/reportDetail?d=${id}`, true)
    },
    goTandem(t) {
      // 跳转串联单详情页
      if (!t.id) return

      common.jump(`/tandem?d=${t.id}`, true)
    },
    goLink(url) {
      if (!url) return

      window.open(url, true)
    }
  }
}
</script>

<style lang="less" src="@assets/css/evaluation/evaluation.less" scoped></style>